import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { services } from '../../services';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-duo-games',
  templateUrl: './lol-duo-games.component.html'
})
export class LolDuoGamesComponent {
  protected readonly DivisionsService = DivisionsService;
  divisionService: typeof DivisionsService = DivisionsService;
  service = 'games';
  availableServices = services['lol'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'lol',
    service: 'games',
    type: 'duo',
    title: {
      en: 'Games',
    },
    subtitle: {
      en: 'Solo and Duo Games with guaranteed performance but no minimum WR',
      fr: 'Jeux en solo et en duo avec des performances garanties mais sans taux de victoire minimum',
      de: 'Solo- und Duo-Spiele mit garantierter Leistung, aber ohne Mindest-Siegrate',
      pt: 'Jogos Solo e Duo com desempenho garantido do Booster e sem WR mínimo',
      es: 'Juegos en solitario y en dúo con rendimiento garantizado pero sin porcentaje mínimo de victorias',
    },
    start: DivisionsService.getValueByRank('Silver I', 'lol'),
    desired: 5,
    serviceName: {
      en: 'Games',
      fr: 'Parties',
      de: 'Spiele',
      pt: 'Jogos',
      es: 'Partidas',
    },
    min: 1,
    max: 5
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Games Boosting Service?",
        answer: "Games is an elo boosting service available for all ranks in Duo Boosting and for Diamond+ in Solo Boosting."
      },
      {
        question: "How Many Games Will I Win?",
        answer: "The service does not guarantee wins but rather provides a certain amount of games. Whatever the case may be, our goal is to maximize both booster performance and win ratio."
      },
      {
        question: "What If I Reach A New Division And Still Have Duo Games Remaining?",
        answer: "In ranks below Diamond we play one division above the initial rank. In Diamond+, games are only valid for the purchased division."
      },
      {
        question: "In Which Game Mode Are Games Played?",
        answer: "Games, being a ranked service, can be played in both Solo/Duo and Flex."
      },
      {
        question: "Can I Purchase Games Before My Placements Are Complete?",
        answer: "Only accounts with all placements completed are eligible for Games."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, unless you want to queue in the same ranking mode as the bought service. Other than that, schedule it in the order chat with your booster."
      }
    ],
    fr: [
      {
        question: "C'est quoi un service de boosting de jeux ?",
        answer: "Games, c'est un service de boosting Elo dispo pour tous les rangs en Duo Boosting et pour Diamant+ en Solo Boosting."
      },
      {
        question: "Combien de parties je vais gagner ?",
        answer: "Le service ne garantit pas de victoires, juste un nombre de parties. On fait tout pour que le booster donne le max et qu'on ait un bon ratio de victoires."
      },
      {
        question: "Et si je passe une division et qu'il me reste des parties en duo ?",
        answer: "Pour les rangs en dessous de Diamant, on joue une division au-dessus de ton rang de départ. Pour Diamant+, les parties comptent que pour la division achetée."
      },
      {
        question: "C'est dans quel mode de jeu ?",
        answer: "Games étant un service classé, tu peux jouer en Solo/Duo ou en Flex."
      },
      {
        question: "Je peux acheter des parties avant de finir mes placements ?",
        answer: "Nope, faut que tous les placements soient terminés pour être éligible."
      },
      {
        question: "Je peux jouer pendant que la commande est active ?",
        answer: "Ouais, sauf si tu veux jouer dans le même mode de classement que le service acheté. Sinon, tu t'arranges avec ton booster dans le chat de commande."
      }
    ],
    de: [
      {
        question: "Was ist ein Games-Boosting-Service?",
        answer: "Games ist ein Elo-Boosting-Service, den es für alle Ränge im Duo Boosting und für Diamant+ im Solo Boosting gibt."
      },
      {
        question: "Wie viele Spiele gewinne ich?",
        answer: "Es gibt keine Garantie für Siege, sondern nur für die Anzahl der Spiele. Wir geben aber alles, um die Leistung des Boosters und die Winrate zu maximieren."
      },
      {
        question: "Was passiert, wenn ich in eine neue Division komme und noch Duo-Spiele übrig habe?",
        answer: "In Rängen unter Diamant spielen wir eine Division höher als dein Start-Rang. Ab Diamant+ gelten die Spiele nur für die gekaufte Division."
      },
      {
        question: "In welchem Modus werden die Spiele gespielt?",
        answer: "Da es ein Ranked-Service ist, kannst du im Solo/Duo- oder im Flex-Modus spielen."
      },
      {
        question: "Kann ich Spiele kaufen, bevor ich meine Placements abgeschlossen habe?",
        answer: "Nee, nur Accounts mit abgeschlossenen Placements sind berechtigt."
      },
      {
        question: "Kann ich spielen, während die Bestellung läuft?",
        answer: "Klar, außer du willst im gleichen Ranked-Modus wie der gekaufte Service spielen. Sonst klär das einfach im Chat mit deinem Booster."
      }
    ],
    pt:[
      {
        question: "O que é um serviço de boosting de jogos?",
        answer: "Games é um serviço de boosting de elo que está disponível para todos os ranks no Duo Boosting e para Diamante+ no Solo Boosting."
      },
      {
        question: "Quantos jogos vou ganhar?",
        answer: "A gente não garante vitórias, só a quantidade de jogos. Mas o objetivo é maximizar tanto o desempenho do booster quanto o ratio de vitórias."
      },
      {
        question: "E se eu subir de divisão e ainda tiver jogos de duo restantes?",
        answer: "Nos ranks abaixo de Diamante, jogamos uma divisão acima do teu rank inicial. Em Diamante+, os jogos só contam pra divisão comprada."
      },
      {
        question: "Em qual modo de jogo vocês jogam?",
        answer: "Como é um serviço ranqueado, pode ser tanto no Solo/Duo quanto no Flex."
      },
      {
        question: "Posso comprar jogos antes de terminar meus placements?",
        answer: "Não, só contas com todos os placements feitos podem comprar o serviço."
      },
      {
        question: "Posso jogar enquanto o pedido está ativo?",
        answer: "Sim, só que não no mesmo modo ranqueado do serviço que compraste. Combina o resto no chat com o teu booster."
      }
    ],
    es: [
      {
        question: "¿Qué es un servicio de boosting de juegos?",
        answer: "Games es un servicio de boosting de elo que está disponible para todos los rangos en Duo Boosting y para Diamante+ en Solo Boosting."
      },
      {
        question: "¿Cuántos juegos voy a ganar?",
        answer: "No garantizamos victorias, solo una cantidad de juegos. Pero vamos a hacer lo posible para que el booster dé lo mejor y el ratio de victorias sea alto."
      },
      {
        question: "¿Y si subo de división y me quedan juegos en dúo?",
        answer: "Si estás por debajo de Diamante, jugamos una división más alta que tu rango inicial. En Diamante+, los juegos solo sirven para la división que compraste."
      },
      {
        question: "¿En qué modo de juego se juegan?",
        answer: "Como es un servicio de ranked, se puede jugar en Solo/Dúo o Flex."
      },
      {
        question: "¿Puedo comprar juegos sin terminar mis placements?",
        answer: "No, solo las cuentas con todos los placements completados pueden hacerlo."
      },
      {
        question: "¿Puedo jugar mientras el pedido está activo?",
        answer: "Sí, a menos que quieras hacer cola en el mismo modo ranqueado que el servicio comprado. Aparte de eso, coordina con tu booster en el chat del pedido."
      }
    ]
  }


  private page = {
    title: {
      en: "LoL Boost - Duo Games Boosting for League of Legends",
      fr: "Boost LoL - Boosting pour parties en duo sur League of Legends",
      de: "LoL Boost - Duo Games Boosting für League of Legends",
      pt: "LoL Boost - Boosting de Jogos Duo para League of Legends",
      es: "LoL Boost - Duo Games Boosting para League of Legends",
    },
    metaDescription: {
      en: "The best option for you to improve your skill in League of Legends. Affordable, fast, and secure. Plus, we offer tips and tricks to help you perform better.",
      fr: "La meilleure option pour améliorer vos compétences sur League of Legends. Abordable, rapide et sécurisé. De plus, nous offrons des conseils et des astuces pour vous aider à améliorer vos performances.",
      de: "Verbessere deine Fähigkeiten in League of Legends - die beste Option. Günstig, schnell und sicher. Wir haben auch Tipps und Tricks, die dir helfen, besser zu werden.",
      pt: "A melhor opção para tu melhorares as tuas habilidades no League of Legends. Acessível, rápido e seguro. Além disso, oferecemos dicas e truques para ajudar-te a ter um melhor desempenho.",
      es: "La mejor opción para mejorar tu habilidad en League of Legends. Asequible, rápida y segura. Además, te ofrecemos consejos y trucos para que mejores tu rendimiento.",
    }
  }

  private lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        }
      );
    });
  }
}